
import { createSelector } from "reselect";

import { AgentStatusPerAgentAndProcess } from "./AgentStatusPerAgentAndProcess";
import { State } from "./State";

import * as _ from "lodash";
import Time from "shared/Time";

const getProcesses = (state: State) => state.processes;
const getCurrentAgentGroup = (state: State) => state.currentAgentGroupName;
const getAgentGroups = (state: State) => state.agentGroups;

const getCurrentAgentNames = createSelector(
    [getCurrentAgentGroup, getAgentGroups],
    (currentAgentGroupName, agentGroups) => {
        const currentGroup = agentGroups[currentAgentGroupName];
        if (currentGroup) {
            return currentGroup.agents && currentGroup.agents.map((a) => a.name) || [];
        }
        return [];
    });

export const getStatusesForAgentsInCurrentAgentGroup = createSelector(
    [getCurrentAgentNames, (state: State) => state.agentStatuses],
    (agents, statuses): AgentStatusPerAgentAndProcess => {
        return _.pick(statuses, agents);
    });

export const getDeployingProcessGuids = createSelector(
    [getProcesses, getStatusesForAgentsInCurrentAgentGroup],
    (processes, agentStatuses) => {
        // the statuses should get recalculated on every new version deploy or agent status update,
        // so caching the time should be OK
        const minTimestampToUse = Time.add(new Date(), { minutes: -30 }).toISOString();
        const deployingProcesses: string[] = [];
        for (const proc of processes) {
            for (const agent of Object.keys(agentStatuses)) {
                const agentStatus = agentStatuses[agent];
                const versionForProcessOnAgent = agentStatus.processInfos && agentStatus.processInfos[proc.uniqueIdentifier];
                if (!versionForProcessOnAgent || proc.version !== versionForProcessOnAgent.version) {
                    if (agentStatus.timestamp > minTimestampToUse) {
                        // ignore statuses for agents that aren't really being updated
                        deployingProcesses.push(proc.uniqueIdentifier);
                    }
                }
            }
        }

        return deployingProcesses;
    }
);
